import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { BaseService } from '../../templates/services/base-service.template';
import { getHttpHeader } from '../../utils/http-header.factory';
import { ApiResponseModel } from '../../models/base/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class MerchantSummaryReviewService implements BaseService {

  public apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'pgw/txn-merchant-summary/review-summary';

  constructor(protected readonly http: HttpClient) {}

  public update(data: { txn_summary_guid: string, review_status: 'ISSUE' | 'ISSUE_RESOLVED' | 'APPROVED'}, { tenantCode, api_domain_url, jwt_secret }: ApiVisa): Observable<ApiResponseModel<any>>{
    return this.http.post<ApiResponseModel<any>>(`${ api_domain_url }${ this.apiUrl }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
